import { makeStyles } from "@material-ui/core";
import { Colors } from "../../helpers/theme";
import { object } from "yup";

const PoolDetailStyle = makeStyles((theme) => ({
  root: {
    overflow: "auto",
    display: "flex",
    width: "100%",
    margin: "0px 0px 0px 0px",
  },
  container: {
    "&.MuiContainer-root": {
      // TODO: remove once Layouts/Templates are done properly
      "padding-right": "8px",
      "padding-left": "8px",
    },
  },
  navRoot: {
    border: "1px solid rgba(227, 230, 236, 1)",
    borderRadius: "15px",
    padding: "5px 10px",
    position: "fixed",
    maxWidth: "150px",
  },
  item: {
    paddingBlock: "2px",
    "&.Mui-selected": {
      backgroundColor: "transparent",
      "& .MuiTypography-body1": {
        color: Colors.greenDark,
      },
      "&:hover": {
        backgroundColor: "transparent",
        "& .MuiTypography-body1": {
          color: Colors.greenDark,
        },
      },
    },
    "&:hover": {
      backgroundColor: "transparent",
      "& .MuiTypography-body1": {
        color: Colors.greenDark,
      },
    },
  },
  itemText: {
    "& .MuiTypography-body1": {
      fontFamily: "Oxygen",
      fontSize: "12px",
      fontWeight: 700,
      textTransform: "uppercase",
      lineHeight: "14px",
      color: "rgba(107, 130, 153, 1)",
    },
  },
  cardRoot: {
    borderRadius: "15px",
    boxShadow: "0px 8px 28px 0px #4D92D512, 0px 4px 6px 0px #06092505",
    minHeight: 350,
  },
  cardContent: {
    borderRadius: "15px 15px 0 0",
    position: "relative",
    top: "-15px",
    background: Colors.white,
    padding: "15px 20px 0px 20px !important",
  },
  floatContainer: {
    position: "absolute",
    top: 10,
    zIndex: 1,
    padding: "0px 20px 0px 20px",
  },
  chip: {
    minWidth: "60px",
    height: "34px",
    fontSize: "14px",
    fontWeight: 700,
    borderRadius: "23px",
    color: Colors.darkWhite,
    "&.green": {
      backgroundColor: Colors.PeurtoRico,
    },
    "&.darkGreen": {
      backgroundColor: Colors.greenDark,
    },
    "&.black": {
      backgroundColor: Colors.black,
    },
    "&.red": {
      backgroundColor: Colors.red,
    },
    "&.yellow": {
      backgroundColor: Colors.alertYellow,
    },
    "&.orange": {
      backgroundColor: Colors.orange,
    },
    "&.default": {
      backgroundColor: Colors.greySlate,
    },
  },
  avatar: {
    width: "2rem",
    height: "2rem",
    border: "3px solid #FFFFFF",
    boxShadow: "0px 4px 15px 0px #0000001A",
  },
  social: {
    display: "flex",
    justifyContent: "space-between",
    fontSize: "16px",
    color: Colors.greySlate,
  },
  socialIcons: {
    border: "1px solid " + Colors.Solitude,
    borderRadius: "50%",
    display: "flex",
    justifyContent: "center",
    width: theme.spacing(1.5),
    height: theme.spacing(1.5),
    padding: "4px",
    "&:hover": {
      background: Colors.greySlate,
      cursor: "pointer",
    },
    "& a": {
      color: Colors.greySlate,
      borderRadius: "50%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    "& a:hover": {
      background: Colors.greySlate,
      color: Colors.white,
      cursor: "pointer",
    },
  },
  title: {
    fontWeight: 700,
    fontSize: "17px",
    lineHeight: "20px",
    color: Colors.greenDark,
    maxWidth: "140px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  token: {
    fontWeight: 400,
    fontSize: "13px",
    lineHeight: "20px",
    color: Colors.greenLight,
  },
  description: {
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "18px",
    padding: "5px",
    marginTop: "10px",
    maxHeight: "70px",
    overflow: "hidden",
  },
  progress: {
    margin: "5px 0px",
    padding: "5px",
  },
  progressBar: {
    backgroundColor: Colors.Solitude,
    color: Colors.PeurtoRico,
  },
  alert: {
    height: 26,
    fontWeight: 400,
    fontSize: "14px",
    fontFamily: "Oxygen",
    alignItems: "center",
    "&.MuiAlert-root": {
      borderRadius: "78px",
      padding: "2px 0px 2px 10px",
      '&:hover': {
        cursor: "pointer",
      }
    },
    "&.approved": {
      backgroundColor: Colors.green,
      color: Colors.white,
      "& .MuiChip-avatar": {
        color: Colors.white,
      }
    },
    "&.unverified": {
      backgroundColor: Colors.orange,
      color: Colors.white,
      "& .MuiChip-avatar": {
        color: Colors.white,
      }
    },
    "&.inreview": {
      backgroundColor: Colors.pendingYellow,
      color: Colors.white,
      "& .MuiChip-avatar": {
        color: Colors.white,
      }
    },
    "&.waiting": {
      backgroundColor: Colors.pendingYellow,
      color: Colors.white,
      "& .MuiChip-avatar": {
        color: Colors.white,
      }
    },
    "&.incomplete": {
      backgroundColor: Colors.orange,
      color: Colors.white,
      "& .MuiChip-avatar": {
        color: Colors.white,
      }
    },
    "&.blocked": {
      backgroundColor: Colors.red,
      color: Colors.white,
      "& .MuiChip-avatar": {
        color: Colors.white,
      }
    },
    "&.rejected": {
      backgroundColor: Colors.red,
      color: Colors.white,
      "& .MuiChip-avatar": {
        color: Colors.white,
      }
    },
    "& .MuiChip-avatar": {
      width: "14px",
      height: "14px",
      marginRight: "1px",
    }
  },
  backers: {
    fontSize: "11px",
    lineHeight: "12px",
    fontWeight: 400,
    margin: "5px 0px",
    padding: "5px",
    "& span": {
      color: Colors.greenLight,
    },
    "& span:hover": {
      cursor: "pointer",
    },
  },
  cardAction: {
    backgroundColor: Colors.white,
    justifyContent: "center",
    padding: "0px 20px",
    marginBottom: "25px",
  },
  cardActionButton: {
    backgroundColor: Colors.greenLight,
    width: "100%",
  },
  banner: {
    borderRadius: "15px",
    height: 350,
    padding: "0px",
    boxShadow: "none",
    border: "none",
    backgroundColor: "#fff",
    margin: 0,
    [theme.breakpoints.down("sm")]: {
      height: 140,
    },
  },
  bannerImage: {
    height: "100%", // Make media height 100% of the card
    width: "100%", // Make media width 100% (optional based on design needs)
    objectFit: "cover", // Cover the container area and zoom if needed
    objectPosition: "center", // Center the image within the container
    pointerEvents: "none", // Disable pointer events on the image
  },
  tab: {
    width: "fit-content",
    minWidth: "auto",
    backgroundColor: Colors.white,
    color: Colors.greySlate,
    fontSize: "1rem",
    fontWeight: 500,
    padding: "5px 20px",
    textTransform: "none",
    border: "1px solid rgba(17, 48, 45, 0.1)",
    borderRadius: "36px",
    marginRight: "15px",
    "&:hover": {
      backgroundColor: Colors.secondaryWhite,
      color: Colors.greySlate,
    },
    "&.Mui-selected": {
      backgroundColor: Colors.greenDark,
      color: Colors.white,
    },
  },
  tabPanel: {
    marginBottom: "5px",
  },
  carouselRoot: {
    width: "100%",
    margin: 0, // Ensuring the carousel itself has no padding or margin
    borderRadius: "15px",
  },
  carouselItem: {
    width: "100%", // Ensures the Paper takes 100% width of its parent
    padding: 0, // Removes padding
    margin: 0, // Removes margin
    position: "relative",
    overflow: "hidden", // Ensures no overflow
    borderRadius: "15px",
  },
  externalLinks: {
    color: Colors.greenLight,
    border: "1px solid " + Colors.greenLight,
  },
  stageRoot: {
    border: "none",
    borderRadius: "15px",
    boxShadow: "0px 8px 28px 0px #4D92D512, 0px 4px 6px 0px #06092505",
    padding: "20px",
    "& h3": {
      fontSize: "23px",
      fontWeight: 600,
    },
    "& span": {
      fontSize: "13px",
      fontWeight: 200,
    },
  },
  sectionHeader: {
    fontSize: "21px",
    lineHeight: "25px",
    color: Colors.greenDark,
    fontWeight: 600,
  },
  teamPaper: {
    width: "100%",
    padding: "10px 0px 0px 10px",
    boxShadow: "0px 8px 28px 0px #4D92D512, 0px 4px 6px 0px #06092505",
    borderRadius: "15px",
  },
  teamAvatar: {
    width: "75px",
    height: "75px",
    borderRadius: "10px",
  },
  teamName: {
    // TODO: Rename these
    fontSize: "17px",
    fontWeight: 400,
    color: Colors.greenDark,
    lineHeight: "22px",
  },
  teamBio: {
    // TODO: Rename these
    fontSize: "13px",
    fontWeight: 400,
    color: Colors.greenDark,
    lineHeight: "20px",
    opacity: "50%",
  },
  teamInfo: {
    // TODO: Rename these
    fontSize: "12px",
    fontWeight: 500,
    lineHeight: "17px",
    letterSpacing: "0em",
    textAlign: "left",
    color: Colors.greenDark,
  },
  logoBanners: {
    width: "100%",
    height: "80px",
    boxShadow: "none",
    background: Colors.black,
    borderRadius: "15px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "10%",
    "& img": {
      maxHeight: "100%",
      maxWidth: "100%",
      objectFit: "contain",
    },
  },
  progressError: {
    display: "flex",
    alignItems: "center",
    color: Colors.lightYellow,
  },
  updateCardRoot: {
    width: "100%",
    height: "auto",
    minHeight: "150px",
    border: "none",
    borderRadius: "15px",
    margin: "10px 0 10px 0",
    boxShadow: "0px 8px 28px 0px #4D92D512, 0px 4px 6px 0px #06092505",
  },
  updateComment: {
    fontSize: "13px",
    fontWeight: 400,
    lineHeight: "17px",
    letterSpacing: "0em",
    textAlign: "left",
    color: Colors.greenDark,
    marginTop: "15px",
  },
  content: {
    maxWidth: "100%",
    marginTop: "1rem",
    "@media (max-width: 768px)": {
      maxWidth: "100%",
    },
    "& body": {
      overflowX: "inherit !important",
      color: "#11302DB2",
      maxWidth: "100%",
      "& h3": {
        fontFamily: "Oxygen, sans-serif",
        color: Colors.greenDark,
        marginTop: "1.5rem",
        fontWeight: 700,
        fontSize: "1.5rem",
        lineHeight: "26px",
      },
      "& p": {
        fontFamily: "Oxygen, sans-serif",
        backgroundColor: "#fff",
        padding: "20px",
        margin: "20px 0px",
        borderRadius: "17px",
        boxShadow: "0px 8px 28px 5px #4D92D512, 0px 4px 10px 5px #06092505",
        transition: "box-shadow 0.3s ease-in-out",
        color: "rgba(17, 48, 45, 0.7)",
        fontSize: "1rem",
        maxWidth: "100%",
        lineHeight: "24px",
        fontWeight: 300,
        wordBreak: "break-word",
        "& img": {
          margin: "10px 0px 10px 0px",
        },
        "& strong": {
          color: " rgba(6, 9, 37, 0.8)",
          fontWeight: 600,
        },
        "& a": {
          color: Colors.greenLight,
        },
      },
    },
    "& img": {
      borderRadius: "17px",
      objectFit: "contain",
      maxWidth: "100%",
      boxShadow: "0px 8px 28px 0px #4D92D512, 0px 4px 6px 0px #06092505",
    },
    "& .partners": {
      display: "grid",
      gridTemplateColumns: "1fr 1fr 1fr 1fr",
      gap: "2rem",
      "@media (max-width: 768px)": {
        gridTemplateColumns: "1fr 1fr 1fr",
      },
      "@media (max-width: 570px)": {
        gridTemplateColumns: "1fr 1fr",
        gap: "1rem",
      },
      "& img": {
        width: "15rem",
      },
    },
  },
}));

export default PoolDetailStyle;
